import { graphql } from "react-relay";

export const dataSourceFragments = {
  dataSource: graphql`
    fragment DataSource_dataSource on DataSource {
      id
      name
      calendarIds
      syncTargets {
        emailAddress
        calendarId
      }
      state
      type
      username
    }
  `,
  org: graphql`
    fragment DataSource_org on Org {
      id
      domains
    }
  `,
};
